import React from 'react';
import ReactDOM from 'react-dom';

import { CarTeaser } from '/components/car-teaser/CarTeaser';

(() => {
    const carTeasers = document.querySelectorAll('[data-car-teaser]');

    carTeasers.forEach((carTeaser) => {
        const car = {
            ...carTeaser.dataset,
            images: JSON.parse(carTeaser.dataset.images),
        };

        ReactDOM.render(
            <CarTeaser car={car} />,
            carTeaser,
        );
    });
})();
